module.exports = __webpack_public_path__ + "static/media/logo-vk.5d4d40d5.svg";